var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      ref: "modal",
      staticClass: "dialog",
      attrs: {
        name: _vm.modalName,
        "modal-props": _vm.compModalProps,
        headerClose: false,
      },
    },
    [
      _c(
        "template",
        { slot: "default" },
        [
          _c(
            _vm.component,
            _vm._b(
              { tag: "component", on: { close: _vm.modalClose } },
              "component",
              _vm.componentProps,
              false
            )
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }